import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core'

const CLICK_EVENT_NAMES = ['click', 'submit']

@Component({ template: '' })
export abstract class AbstractButtonComponent implements AfterViewInit, OnDestroy {
  @Input()
  disabled: boolean

  @ViewChild('abstractReferenceId', { read: ElementRef })
  protected buttonRef: ElementRef

  protected parentElement: any

  isDisabled() {
    return this.disabled
  }

  ngAfterViewInit(): void {
    this.parentElement = this.buttonRef?.nativeElement?.parentElement
    this.addListeners()
  }

  ngOnDestroy(): void {
    this.removeListeners()
  }

  protected addListeners() {
    CLICK_EVENT_NAMES.forEach((eventName) =>
      this.parentElement?.addEventListener(eventName, this.eventListenerHandler, true)
    )
  }

  protected removeListeners() {
    CLICK_EVENT_NAMES.forEach((eventName) =>
      this.parentElement?.removeEventListener(eventName, this.eventListenerHandler, true)
    )
  }

  protected eventListenerHandler = (event: Event): void => {
    if (this.isDisabled()) {
      event.preventDefault()
      event.stopImmediatePropagation()
      event.stopPropagation()
    }
  }
}
